import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { doc, getDoc } from 'firebase/firestore';
import { db } from '../../firebase-client';
import TeamDetails from './teamDetail';

// Resolve the readable address while retaining the real ID for data access,
// permissions, and existing navigation throughout the club.
export default function ClubUrlRoute() {
  const { id } = useParams();
  const [resolved, setResolved] = useState(null);
  const [failed, setFailed] = useState(false);
  useEffect(() => {
    let cancelled = false;
    setFailed(false);
    setResolved(null);
    // Generated IDs containing uppercase letters cannot be custom names.
    // Keep their existing offline loading path without an extra lookup.
    if (!/^[a-z0-9]+(?:-[a-z0-9]+)*$/.test(id)) {
      setResolved({ path: id, teamId: id });
      return () => { cancelled = true; };
    }
    getDoc(doc(db, 'clubUrlSlugs', id))
      .then((snapshot) => {
        if (!cancelled) setResolved({ path: id, teamId: snapshot.exists() ? snapshot.data().teamId : id });
      })
      .catch(() => { if (!cancelled) setFailed(true); });
    return () => { cancelled = true; };
  }, [id]);
  if (failed) return <p role="alert">Could not load this club. Please refresh and try again.</p>;
  if (resolved?.path !== id) return <p role="status">Loading club…</p>;
  return <TeamDetails key={resolved.teamId} resolvedTeamId={resolved.teamId} />;
}
